var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecommandationImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 166,
    viewBox: "0 0 320 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2788_2680)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2788_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 166,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M194 8.97733C194 62.2254 319.491 173.663 385.234 173.663C450.978 173.663 426.567 127.891 426.567 74.6434C426.567 21.3953 373.271 -21.7708 307.528 -21.7708C241.784 -21.7708 194 -44.2707 194 8.97733Z",
    fill: "#00D7C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M227 94.3372C227 147.585 352.491 259.023 418.234 259.023C483.978 259.023 459.567 213.251 459.567 160.003C459.567 106.755 406.271 63.5891 340.528 63.5891C274.784 63.5891 227 41.0891 227 94.3372Z",
    fill: "#00D7C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M432.794 103.793C384.773 82.6056 234.357 139.501 208.206 192.538C182.055 245.575 233.044 244.094 281.065 265.282C329.086 286.469 389.214 260.65 415.365 207.613C441.517 154.576 480.815 124.98 432.794 103.793Z",
    fill: "#00D7C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2788_2680",
    x: -10,
    y: -2,
    width: 340,
    height: 186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.615686 0 0 0 0 0.647059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2788_2680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2788_2680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2788_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 166,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecommandationImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recommandationImg.9a77488e9809ae1f6e3b8d670485b4af.svg";